import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, File as CustomFile } from 'types';
import { client } from 'utils/api-client';

type FileUpload = {
  file: File;
  description: string;
  athlete: string;
  fileType: string;
};

export default function useCreateFile(): UseMutationResult<
  AxiosResponse<CustomFile>,
  AxiosError<ErrorMessage>,
  FileUpload
> {
  const queryClient = useQueryClient();

  const createFile = (file: FileUpload): Promise<AxiosResponse<CustomFile>> => {
    const formData = new FormData();
    formData.append('file', file.file);
    formData.append('description', file.description);
    formData.append('athlete', file.athlete);
    formData.append('fileType', file.fileType);
    return client.post('files/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  return useMutation(createFile, {
    onSuccess: () => {
      queryClient.invalidateQueries('files');
    },
  });
}
